
import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import { reducer as uiReducer } from 'redux-ui'
import {reducer as formReducer} from 'redux-form';
import { hashHistory } from 'react-router';
import { routerReducer } from 'react-router-redux';

import reduxFormPlugin from "./redux-form-plugin";


//Showcase Reducers
import config from './config/reducers.js';
const appReducers = {
	config
};

const app = combineReducers({
	...appReducers,
	ui: uiReducer,
	form: formReducer.plugin(reduxFormPlugin),
	routing: routerReducer
});


let store = createStore(app, {}, compose(
	window.devToolsExtension ? window.devToolsExtension() : f => f
));


export default store;
